module.exports = __webpack_public_path__ + "media/paliwa/on@3x-f60ef32c.svg";